module.exports = __webpack_public_path__ + "img/ogates.280beabd.png";